<script>
import ParkingPassForm from "./Forms/ParkingPassForm.vue";
export default {
  components: { ParkingPassForm },
};
</script>

<template>
  <div class="md-layout md-alignment-center-center flex-1">
    <div
        class="md-layout-item md-small-size-100 md-large-size-50 md-xlarge-size-33"
    >
      <div style="text-align:center; margin-bottom:20px">
        <img src="@/assets/img/logos/logo-sml.png" width="300px" />
      </div>
      <md-card>
        <md-card-header style="background-color: #2560a6">
          <h4 class="title">Purchase a Parking Pass</h4>
        </md-card-header>
        <md-card-content>
          <parking-pass-form />
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<style scoped>

</style>